import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const ICON1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="111" height="111" viewBox="0 0 111 111" fill="none">
        <g clipPath="url(#clip0_47_692)">
            <path
                d="M89.3377 33.6253C89.3377 51.576 74.7854 66.1318 56.8312 66.1318C38.8771 66.1318 24.3247 51.5795 24.3247 33.6253C24.3247 15.6746 38.8771 1.11877 56.8312 1.11877C74.7854 1.11877 89.3377 15.6711 89.3377 33.6253Z"
                fill="#D4ECFE"
                fillOpacity="0.4"
            />
            <path
                d="M83.6601 67.6607C76.0851 73.6408 66.6963 76.9627 56.8314 76.9627C46.8518 76.9627 37.3727 73.5644 29.7629 67.4696C9.7065 74.8327 0.748535 100.563 0.748535 112.315H112.348C112.348 100.668 103.32 75.1176 83.6601 67.6642V67.6607Z"
                fill="#D4ECFE"
                fillOpacity="0.4"
            />
        </g>
        <defs>
            <clipPath id="clip0_47_692">
                <rect width="111.631" height="111.631" fill="white" transform="translate(0.748535 0.901611)" />
            </clipPath>
        </defs>
    </svg>
);

const ICON2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="116" height="110" viewBox="0 0 116 110" fill="none">
        <g clipPath="url(#clip0_47_695)">
            <path
                d="M72.7157 115.708V155.719H71.4653C60.4623 148.802 51.2098 136.209 45.2081 120.65C53.7105 117.929 63.2131 116.198 72.7157 115.708ZM82.7184 115.708C91.3558 115.958 99.9982 117.674 107.725 120.86C102.274 136.329 94.0865 148.847 83.8537 155.719H82.7184V115.708ZM118.453 123.21C123.462 125.639 128.242 128.517 132.732 131.808C124.26 140.16 114.097 146.787 102.724 150.718C109.016 143.106 114.342 133.773 118.453 123.21ZM36.9809 123.21C41.092 133.773 46.4185 143.106 52.7102 150.718C41.3948 146.788 31.1296 140.32 22.702 131.808C27.1223 128.413 31.9123 125.529 36.9809 123.21ZM155.238 83.1993C154.242 98.7515 148.432 113.608 138.614 125.711C133.072 121.61 126.776 118.224 120.229 115.323C123.25 105.42 125.015 94.5524 125.52 83.1993H155.238ZM27.7934 83.1993C28.2635 94.5524 29.8939 105.42 32.7047 115.323C26.6086 118.072 20.8739 121.561 15.63 125.711C6.7476 113.878 1.13106 99.1386 0.195801 83.1993H27.7934ZM115.227 83.1993C114.767 92.7569 113.382 102.314 110.846 110.707C102.084 107.676 92.6311 106.046 82.7184 105.58V83.1993H115.227ZM72.7157 83.1993V105.62C62.2878 106.086 51.86 107.701 42.4224 110.707C39.6916 102.154 38.2012 92.6769 37.7061 83.1993H72.7157ZM15.63 30.6849C20.7814 34.791 26.623 38.1719 32.7047 41.0727C29.8989 50.9754 28.2635 61.8434 27.7934 73.1965H0.195801C1.13106 57.2521 6.7476 42.5231 15.63 30.6849ZM138.614 30.6849C148.432 42.7873 154.242 57.6443 155.238 73.1965H125.52C125.015 61.8434 123.25 50.9754 120.229 41.0727C127.031 38.1719 133.072 34.791 138.614 30.6849ZM110.846 43.1883C113.382 52.5209 114.767 62.8587 115.227 73.1965H82.7184V48.7398C92.4011 48.2297 102.084 46.4692 110.846 43.1883ZM42.4274 43.1883C51.86 46.4942 62.0378 48.2747 72.7157 48.7848V73.1965H37.7061C38.2062 62.7687 39.6916 52.3408 42.4224 43.1883H42.4274ZM83.8487 0.676636C93.8515 7.1184 102.264 18.8566 107.72 33.5857C99.6191 36.196 91.2132 37.7427 82.7134 38.1869V0.676636H83.8487ZM72.7157 0.676636V38.1869C63.2131 37.7218 53.7105 36.1013 45.2081 33.5557C51.2098 18.9667 60.4623 7.15841 71.4653 0.676636H72.7157ZM52.7102 3.17732C46.3685 10.7894 41.002 20.122 37.0959 30.6849C31.9745 28.2292 27.0932 25.2834 22.702 22.0875C30.9992 13.4952 41.2421 7.1084 52.7102 3.17732ZM102.724 3.17732C114.192 7.1084 124.435 13.4952 132.732 22.0875C128.322 25.4333 123.579 28.316 118.578 30.6899C114.437 20.117 109.071 10.7844 102.724 3.17732Z"
                fill="#D4ECFE"
                fillOpacity="0.4"
            />
        </g>
        <defs>
            <clipPath id="clip0_47_695">
                <rect width="155.043" height="155.043" fill="white" transform="translate(0.195801 0.676636)" />
            </clipPath>
        </defs>
    </svg>
);

const ICON3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="110" viewBox="0 0 114 110" fill="none">
        <g clipPath="url(#clip0_47_697)">
            <path
                d="M78.4665 0.676636C52.0289 28.7208 14.3296 25.043 14.3296 25.043V100.446C84.9026 224.811 142.603 100.446 142.603 100.446V25.043C142.603 25.043 102.144 29.6403 78.4665 0.676636ZM107.129 59.5443L64.9469 101.727C64.2983 102.371 63.4214 102.732 62.5074 102.732C61.5935 102.732 60.7166 102.371 60.068 101.727L42.0768 83.7336C41.4379 83.0853 41.0813 82.2107 41.0847 81.3005C41.0881 80.3902 41.4513 79.5183 42.0951 78.8748C42.7388 78.2313 43.6109 77.8685 44.5211 77.8654C45.4313 77.8623 46.3058 78.2193 46.9539 78.8584L62.5084 94.413L102.252 54.6672C102.903 54.0425 103.774 53.6979 104.676 53.7073C105.578 53.7167 106.441 54.0793 107.079 54.7174C107.717 55.3555 108.08 56.2183 108.089 57.1206C108.099 58.023 107.754 58.8931 107.129 59.5443Z"
                fill="#D4ECFE"
                fillOpacity="0.4"
            />
        </g>
        <defs>
            <clipPath id="clip0_47_697">
                <rect width="155.043" height="155.043" fill="white" transform="translate(0.945312 0.676636)" />
            </clipPath>
        </defs>
    </svg>
);

const ICON4 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="115" height="110" viewBox="0 0 115 110" fill="none">
        <path
            d="M24.802 48.6227C24.802 52.9388 25.6512 57.2127 27.3012 61.2003C28.9512 65.1879 31.3696 68.8111 34.4184 71.8631C37.4672 74.9151 41.0866 77.3361 45.07 78.9878C49.0535 80.6395 53.3229 81.4896 57.6345 81.4896C61.9461 81.4896 66.2155 80.6395 70.1989 78.9878C74.1824 77.3361 77.8018 74.9151 80.8506 71.8631C83.8993 68.8111 86.3178 65.1879 87.9677 61.2003C89.6177 57.2127 90.467 52.9388 90.467 48.6227C90.467 44.3065 89.6177 40.0326 87.9677 36.045C86.3178 32.0574 83.8993 28.4342 80.8506 25.3822C77.8018 22.3303 74.1824 19.9093 70.1989 18.2576C66.2155 16.6059 61.9461 15.7557 57.6345 15.7557C53.3229 15.7557 49.0535 16.6059 45.07 18.2576C41.0866 19.9093 37.4672 22.3303 34.4184 25.3822C31.3696 28.4342 28.9512 32.0574 27.3012 36.045C25.6512 40.0326 24.802 44.3065 24.802 48.6227Z"
            fill="#D4ECFE"
            fillOpacity="0.4"
        />
        <path
            d="M83.0773 78.4472C77.0566 85.8281 67.896 90.5623 57.6345 90.5623C47.373 90.5623 38.2124 85.8176 32.1917 78.4368C13.2752 84.8474 0.268799 101.096 0.268799 116.508C0.268799 130.546 115 130.546 115 116.508C115 101.096 101.994 84.8578 83.0773 78.4472ZM102.889 35.3811C97.5188 15.3726 79.2665 0.676636 57.6347 0.676636C36.0168 0.676636 17.7744 15.3533 12.3905 35.3414C7.37115 36.3664 3.43936 41.4263 3.43936 47.5184C3.43936 54.3502 8.38253 59.8642 14.2606 59.8642C17.1889 59.8642 18.658 53.7928 18.6685 47.5366H18.7906C18.7906 26.1739 36.216 8.67605 57.6348 8.67605C78.5483 8.67605 95.6515 25.3618 96.4467 46.0668C96.2004 52.6925 97.6599 59.8825 100.827 59.8825C106.705 59.8825 111.649 54.3473 111.649 47.5155C111.648 41.5009 107.817 36.4941 102.889 35.3811Z"
            fill="#D4ECFE"
            fillOpacity="0.4"
        />
    </svg>
);

export default function B() {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');

    const reasonList = [
        {
            key: 'reason_1',
            text: t.rich('sectionB_reason_1', {
                big: (text: string) => <span className="big">{text}</span>,
            }),
            icon: <ICON1 />,
        },
        {
            key: 'reason_2',
            text: t.rich('sectionB_reason_2', {
                big: (text: string) => <span className="big">{text}</span>,
            }),
            icon: <ICON2 />,
        },
        {
            key: 'reason_3',
            text: t.rich('sectionB_reason_3', {
                big: (text: string) => <span className="big">{text}</span>,
            }),
            icon: <ICON3 />,
        },
        {
            key: 'reason_4',
            text: t.rich('sectionB_reason_4', {
                blue: (text: string) => <span className="blue">{text}</span>,
            }),
            icon: <ICON4 />,
        },
    ];

    return (
        <div className={`amazon-sale-B ${css['amazon-sale-B']}`}>
            <div className="section-content">
                <p className="title">{t('sectionB_title')}</p>
                <div className="reason-content">
                    {reasonList.map((item) => (
                        <div className="reason" key={item.key}>
                            <p className="text">{item.text}</p>
                            {item.icon}
                        </div>
                    ))}
                </div>
                <p className="tips">{t('sectionB_tips')}</p>
            </div>
        </div>
    );
}
